import React from 'react';
import classNames from 'classnames';
import { Container, Navbar } from 'shards-react';
import NavbarNav from './NavbarNav/NavbarNav';
import NavbarToggle from './NavbarToggle';

const MainNavbar = () => {
	const classes = classNames('main-navbar', 'bg-white', 'sticky-top', 'p-0');

	return (
		<Container fluid className={classes}>
			<Navbar type='light' className='align-items-stretch flex-md-nowrap p-0'>
				<NavbarToggle />
				<NavbarNav />
			</Navbar>
		</Container>
	);
};

export default MainNavbar;
